<svelte:options accessors/>
<script>
// Simple modal dialog that presents the user with some options

// text to show the user above the buttons
export let text = 'Proceed with this action?';

// list of buttons and value to send to the callback when clicked
// each must have at least a .label member
export let buttons = [{label:'Ok'}, {label:'Cancel'}];

export let allowCancel = true;

// returned to the caller
export let choice = null;

export function CanClose(withCode)
{
    return allowCancel || withCode == MODAL_OK;
}

function Go(value)
{
    choice = value;
    HideModal(MODAL_OK);
}

</script>

<div class="dialog">
  <section>
    <header style="display:flex; justify-content: center; margin-bottom: 1em;">
      <div class="image"><img src="images/smallBlackLogo.png" alt="" /></div>
    </header>
  </section>

	 <section class="line-after">
      <header style="display:flex; justify-content: center;">
          <center>
            <h4>{@html text}</h4>
          </center>
      </header>
    </section>
    <div>
        <ul class="actions special" style="margin-bottom: 0;">
        {#each buttons as b, i}
            <li><div class="button primary" on:click="{() => Go(b)}">{b.label}</div></li>
        {/each}
        </ul>
    </div>
</div>

<style>

section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

h4, p, label, input
{
    color: black;
}

.dialog
{
    min-width: 300px;
    max-width: 400px;
    padding: 20px;
    z-index: 99;
    font-size: 13pt;
}

.button.primary {
  width: 100%;
  background-color: #4a98e2 !important;
  margin-top: 1em;
}

li { width: 100%; }

</style>
